globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalEditComment = (function(superClass)
{
    utils.extend(ModalEditComment, superClass);

    function ModalEditComment($html) {
      return ModalEditComment.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalEditComment.prototype, {
      init: function() {
        ModalEditComment.__super__.init.apply(this, arguments);
      },
      callbackSuccess: function(data) {
        if(data.response) {
          $('[data-comment-id=' + data.comment_id + ']').each(function (index) {
            $(this).html(data.html)
          });
        }

        ModalEditComment.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalEditComment;
})(backoffice.ModalMain);
